import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Segment } from '../types/segment.type';
import { CreateSegmentRequestDTO } from '../types/dtos/create-segment.dto';
import { ADMIN_SEGMENTS_API_PATHS } from '../constants/segments-api-paths.constants';

type UseCreateSegmentResult = {
  isSubmitting: boolean;
  createSegment: (data: CreateSegmentRequestDTO) => Promise<Segment | null>;
};

export function useCreateSegment(): UseCreateSegmentResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createSegment = async (data: CreateSegmentRequestDTO): Promise<Segment | null> => {
    setIsSubmitting(true);

    try {
      const createdSegment = await HttpClient.post<Segment, CreateSegmentRequestDTO>(
        ADMIN_SEGMENTS_API_PATHS.CREATE_SEGMENT,
        data
      );

      enqueueSnackbar('Segment créé', { variant: 'success' });
      return createdSegment;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création du segment'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, createSegment };
}
